import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Meetup } from '../../models/meetup';
import { MoneyPerMeetup } from '../../models/money-per-meetup';
import { MeetupService } from '../../services/meetup.service';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-money-per-meetup',
  templateUrl: './money-per-meetup.component.html',
  styleUrls: ['./money-per-meetup.component.scss']
})
export class MoneyPerMeetupComponent implements OnInit {
	public meetups: Observable <Meetup[]>;
	public money: Observable<MoneyPerMeetup[]>;

  constructor(private meetupService: MeetupService,
		private reportService: ReportService) {
		this.meetups = this.meetupService.getMeetups();
		this.money = this.reportService.getMoneyPerMeetups();
	}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/money-per-meetup/money-per-meetup.component.ts